<template>
	<v-dialog scrollable persistent v-model="dialog" @click:outside="closeDialog()" @keyup.esc="closeDialog()" max-width="400">
		<v-card>
			<v-card-title>
				<v-btn icon @click="closeDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="text-center font-14">
				Na pewno chcesz usunąć ten plik?
			</v-card-text>
			<v-card-actions class="justify-content-center py-5 px-6">
				<v-btn @click="closeDialog()">Nie</v-btn>
				<v-btn :loading="saving" @click="submit()" color="accent">Tak</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from 'axios';
export default {
	data() {
		return {
			dialog: false,
			saving: false,
			file: null
		}
	},
	methods: {
		closeDialog() {
			this.$emit('closed');
			this.dialog = false;
		},
		async submit() {
			if(this.file) {
				this.saving = true;
				await axios.delete(`files/${this.file.id}`)
					.then(() => {
						this.$emit('deleted', this.file);
						this.closeDialog();
						this.$toast.success("Pomyślnie usunięto plik")
					})
					.catch(error => {
						console.log("DELETE ERROR", error);
						this.$toast.error("Wystąpił błąd")
					})
				this.saving = false;
			}
		},
		showDialog(file) {
			this.file = file;
			this.dialog = true;
		}
	}
}
</script>